import {
  Icon,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
} from "@chakra-ui/react";
import ReactDatePicker, { ReactDatePickerProps } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IconType } from "react-icons";
import { RiCalendarTodoFill } from "react-icons/ri";
import "./englishdatepicker.css";
import { useRef } from "react";

interface EnglishDatePickerWithOutIconProps
  extends Omit<ReactDatePickerProps, "icon"> {
  showPopperArrow?: boolean;
  isClearable?: boolean;
}
export interface EnglishDatePickerProps
  extends EnglishDatePickerWithOutIconProps {
  icon?: IconType;
  dateFormat?: string;
  size?: InputProps["size"];
}

export function EnglishDatePicker({
  icon = RiCalendarTodoFill,
  showPopperArrow = true,
  isClearable,
  dateFormat = "yyyy-MM-dd",
  size,
  ...props
}: EnglishDatePickerProps) {
  const datePickerRef = useRef<ReactDatePicker>(null);
  return (
    <InputGroup
      position="relative"
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
      size={size}
    >
      <ReactDatePicker
        ref={datePickerRef}
        isClearable={isClearable}
        dateFormat={dateFormat}
        showYearDropdown
        showMonthDropdown
        closeOnScroll
        calendarClassName="english_date_picker__calendar"
        wrapperClassName="english_date_picker__wrapper"
        popperClassName="english_date_picker__popper"
        showPopperArrow={showPopperArrow}
        portalId="root-portal"
        dropdownMode="select"
        className="english_date_picker"
        {...props}
        customInput={<Input size={size} />}
      />
      <InputRightElement
        color="surface.600"
        onClick={() => datePickerRef.current?.setOpen(true)}
      >
        <Icon as={icon} />
      </InputRightElement>
    </InputGroup>
  );
}
